import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Message } from 'primeng/primeng';
import { RoleService } from '../../../service/role/role.service';
import { Role } from '../../../class/role';

@Component({
  selector: 'app-role',
  templateUrl: './role.component.html',
  styleUrls: ['./role.component.scss']
})
export class RoleComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() infoRole: Role;
    public role: Role;
    public msgs: Message[] = [];
    public options: any;

    constructor(
        public roleService: RoleService,
        private activatedRoute: ActivatedRoute) {
    }

    ngOnInit() {
    }

    public cancelRole () {
        this.close.emit(true);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/roles/role/role.component.ts